// Lenis Scrolling text + gsap
// https://github.com/studio-freight/lenis
// https://greensock.com
let firstParallaxObj = document.querySelector('.parallax-title__text--first');
let lastParallaxObj = document.querySelector('.parallax-title__text--last');


//Global parallax functions
let parallaxBehind = (elFirst, elLast) => {
	if (typeof(elFirst) != 'undefined' && elFirst != null) {
		if (elFirst.style.transform) {
			elLast.style.transform = elFirst.style.transform;
		}
	}
}

const lenis = new Lenis({
	duration: 1.2,
	easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
});

function raf(time) {
	lenis.raf(time);
	requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

// Specific parallax functions for parallax-title element
if (typeof(firstParallaxObj) != 'undefined' && firstParallaxObj != null) {

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: '.parallax-title',
			scrub: true
		}
	}).to(firstParallaxObj, {
		stagger: .2,
		x: - (window.innerWidth / 2),
		scrub: true
	});

}

// Lenis scrolling image
const prx = gsap.timeline({
	scrollTrigger: {
		trigger: '.parallax',
		scrub: true
	}
}).to('.parallax__image', {
	y: -450,
	scrub: true
});

//Same, but for page template
let firstHeadingObj = document.querySelector('.heading__big-title--first');
let lastHeadingObj = document.querySelector('.heading__big-title--last');

if (typeof(firstHeadingObj) != 'undefined' && firstHeadingObj != null) {

	const tl = gsap.timeline({
		scrollTrigger: {
			// trigger: document.body,
			x: 0,
			scrub: true
		}
	}).to(firstHeadingObj, {
		stagger: .3,
		x: - (window.innerWidth / 1.5),
		scrub: true
	});

}

// Lenis scrolling image
const hdg = gsap.timeline({
	scrollTrigger: {
		trigger: '.parallax',
		scrub: true
	}
}).to('.parallax__image', {
	y: -450,
	scrub: true
});


// Accordion
let accordions = document.querySelectorAll('.accordion');

function deactivateSiblings() {
	for (const accordion of accordions) {
		accordion.classList.remove('active');
	}
}

for (let i = 0; i < accordions.length; i++) {
	let accordion = accordions[i];
	let accordionBtn = accordion.querySelector('.accordion__header');
	accordionBtn.addEventListener('click', function() {
		if (accordion.classList.contains('active')) {
			accordion.classList.remove('active');
		} else {
			deactivateSiblings();
			accordion.classList.add('active');
		}
	});
}

// Addresses block
	let addresses = document.querySelectorAll('.addresses__block');
	let addressBg = document.querySelector('.addresses__bg');

	function deactivateSiblingsAddr() {
		for (const address of addresses) {
			if (typeof(address) != 'undefined' && address != null) {
				address.classList.remove('active');
			}
		}
	}

	let setBg = (el) => {
		let addrSrc = el.querySelector('.addresses__figure img').getAttribute('src');
		console.log(addrSrc);
		addressBg.style.backgroundImage = "url('" + addrSrc + "')"; 
	}

	for (let i = 0; i < addresses.length; i++) {
		let addr = addresses[i];
		if (typeof(addr) != 'undefined' && addr != null) {
			if (addr.classList.contains('active')) {
				setBg(addr);
			}
			addr.addEventListener('click', function() {
				setBg(addr);
				if (addr.classList.contains('active')) {
					addr.classList.remove('active');
				} else {
					deactivateSiblingsAddr();
					addr.classList.add('active');
				}
			});
		}
	}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

let baseUrl = window.location.origin;

const header = document.querySelector('.header');
const navbarMenu = document.querySelector('.js-header__nav');
const burgerMenu = document.querySelector('.js-header__trigger');
const overlayMenu = document.querySelector('.header__overlay');
const menuItems = document.querySelectorAll('.menu-item a');

// Menu title
var menuItem = document.querySelectorAll('.menu-item a');

for(let i = 0; i < menuItems.length; i++ ) {
  let menuItem = menuItems[i];
	var innerContent = menuItem.innerHTML;
	menuItem.setAttribute("title", innerContent);
}

// insertAfter
function insertAfter(newNode, existingNode) {
  existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
}

// Guess what it does
function removeHash() { 
  history.replaceState(null, null, ' ');
}


// Add button to sub menu
const childrenedLink = document.querySelectorAll('.menu-item-has-children > a');

function subMenu() {

	for(let i = 0; i < childrenedLink.length; i++) {
    childrenedLink[i].addEventListener("click", () => {
			if(i > 0 ) {
				childrenedLink.forEach(child => {
					child.classList.remove('active');
				});
			}
      childrenedLink[i].classList.toggle("active");
    });
  }

}

subMenu();

// Toggle Menu Function
burgerMenu.addEventListener('click', toggleMenu);

function toggleMenu() {
	navbarMenu.classList.toggle('active');
	overlayMenu.classList.toggle('active');
	burgerMenu.classList.toggle('active');
	if(header.classList.contains('active')) {
		header.classList.remove('active');
		setTimeout(() => {
			header.classList.remove('transitioned');
		}, "300");
	} else {
		header.classList.add('transitioned');
		header.classList.add('active');
	}
}

//DOM load
document.addEventListener("DOMContentLoaded", function(event) {

		//style form select options
		let formSelect = document.querySelector('.wpcf7-select');
		if (typeof(formSelect) != 'undefined' && formSelect != null) {
			customSelect(formSelect);
			const cstSel =  formSelect.customSelect
			const option = cstSel.select.options[0];
			option.disabled = true;
		}

		// Parallax-related stuff (see 'Lenis')
		parallaxBehind(firstParallaxObj, lastParallaxObj);
		parallaxBehind(firstHeadingObj, lastHeadingObj);

		window.addEventListener('scroll', function() {
			parallaxBehind(firstParallaxObj, lastParallaxObj);
			parallaxBehind(firstHeadingObj, lastHeadingObj);
		});

		let prestaExists = document.querySelector('.splide-presta');
		let testimoniesExists = document.querySelector('.splide-testimonies');
		let beforeExists = document.querySelector('.splide-before');
		let afterExists = document.querySelector('.splide-after');
		let servicesExists = document.querySelector('.splide-services');

		if (typeof(prestaExists) != 'undefined' && prestaExists != null) {

					// Carousel Prestations
					let carouselPresta = new Splide( prestaExists, {
						type: 'loop',
						arrows: true,
						pagination: false,
						perPage: 3,
						perMove: 1,
						focus: 0,
						speed: 1000,
						snap: true,
						easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
						arrowPath: 'M 24.453125 5.695312 L 22.304688 7.84375 L 32.992188 18.53125 L 1.230469 18.53125 L 1.230469 21.566406 L 32.894531 21.566406 L 22.304688 32.15625 L 24.453125 34.304688 L 36.609375 22.148438 L 36.621094 22.15625 L 38.769531 20.007812 L 38.757812 20 L 38.769531 19.992188 L 36.621094 17.84375 L 36.609375 17.851562 Z M 24.453125 5.695312',
						breakpoints: {
							1024: {
								// fixedWidth : '33.3%',
								perPage: 1,
								perMove: 1,
							},
						}
					} );

			let carouselPrestaProgress = document.querySelector('.splide-presta__progress');
			let carouselPrestaBar = carouselPresta.root.querySelector( '.splide-presta__progress-bar' );

			let definePrestaBarWidth = () => {
				let carouselPrestaFirst = document.querySelector( '.splide-presta__block--first' ).offsetWidth;
				carouselPrestaProgress.style.width = carouselPrestaFirst + "px";
			}

			// Updates the bar width whenever the carousel moves:
			carouselPresta.on( 'mounted move', function () {
			let end  = carouselPresta.Components.Controller.getEnd() + 1;
			let rate = Math.min( ( carouselPresta.index + 1 ) / end, 1 );
			carouselPrestaBar.style.width = String( 100 * rate ) + '%';

			definePrestaBarWidth();
			window.addEventListener('resize', () => {
				throttle(definePrestaBarWidth, false, 100);
				});
			} );

			carouselPresta.mount();

		}

		if (typeof(testimoniesExists) != 'undefined' && testimoniesExists != null) {
			// Carousel Testimonies
			let carouselTestimonies = new Splide( testimoniesExists, {
				type: 'loop',
				arrows: false,
				pagination: true,
				perPage: 1,
				perMove: 1,
				focus: 0,
				speed: 1000,
				snap: true,
				easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
				arrowPath: 'M 24.453125 5.695312 L 22.304688 7.84375 L 32.992188 18.53125 L 1.230469 18.53125 L 1.230469 21.566406 L 32.894531 21.566406 L 22.304688 32.15625 L 24.453125 34.304688 L 36.609375 22.148438 L 36.621094 22.15625 L 38.769531 20.007812 L 38.757812 20 L 38.769531 19.992188 L 36.621094 17.84375 L 36.609375 17.851562 Z M 24.453125 5.695312',
			} );

			carouselTestimonies.mount();
		}

		if (typeof(beforeExists) != 'undefined' && beforeExists != null) {
			// Carousel Before
			let carouselBefore = new Splide( beforeExists, {
				type: 'loop',
				arrows: false,
				pagination: false,
				direction: "rtl",
				perPage: 1,
				perMove: 1,
				focus: 0,
				speed: 1000,
				snap: true,
				easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
			} );
			let carouselAfter = new Splide( afterExists, {
				type: 'loop',
				arrows: false,
				pagination: false,
				perPage: 1,
				perMove: 1,
				focus: 0,
				speed: 1000,
				snap: true,
				easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
			} );
			carouselBefore.sync( carouselAfter );
			carouselBefore.mount();
			carouselAfter.mount();

			let beforeAfterPrev = document.querySelector(".beforeafter__prev");
			let beforeAfterNext = document.querySelector(".beforeafter__next");
	
			beforeAfterNext.addEventListener('click', e => {
				carouselBefore.go('+1')
			});
			beforeAfterPrev.addEventListener('click', e => {
				carouselBefore.go('-1')
			});
		}

		if (typeof(servicesExists) != 'undefined' && servicesExists != null) {
			// Carousel Test
			var carouselServices = new Splide( servicesExists, {
				type: 'loop',
				arrows: true,
				pagination: false,
				perPage: 3,
				perMove: 1,
				focus: 0,
				speed: 1000,
				snap: true,
				easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
				arrowPath: 'M 24.453125 5.695312 L 22.304688 7.84375 L 32.992188 18.53125 L 1.230469 18.53125 L 1.230469 21.566406 L 32.894531 21.566406 L 22.304688 32.15625 L 24.453125 34.304688 L 36.609375 22.148438 L 36.621094 22.15625 L 38.769531 20.007812 L 38.757812 20 L 38.769531 19.992188 L 36.621094 17.84375 L 36.609375 17.851562 Z M 24.453125 5.695312',
				breakpoints: {
					1024: {
						// fixedWidth : '33.3%',
						perPage: 1,
						perMove: 1,
					},
				}
			} );
			carouselServices.mount();
		}

}); //end of DOM load

function collapseSubMenu() {
	navbarMenu.querySelector('.menu-item-has-children.active .sub-menu').removeAttribute('style');
	navbarMenu.querySelector('.menu-item-has-children.active').classList.remove('active');
}

// Fixed Resize Screen Function
window.addEventListener('resize', () => {
	if (window.innerWidth > 992) {
		// If navbarMenu is Open, then Close It
		if (navbarMenu.classList.contains('active')) {
			toggleMenu();
		}

		// If menu-item-child is Expanded, then Collapse It
		if (navbarMenu.querySelector('.menu-item-has-children.active')) {
			collapseSubMenu();
		}
	}
});

// SCROLL-RELATED FUNCTIONS

/* Animate on scroll */
let scrollOffset = 100;
let scrollElements = document.querySelectorAll(".js-scroll");

//initialize throttleTimer as false
let timerOne, timerTwo, timerThree = false;
 
let throttle = function(callback, throttleTimer, time) {

    //don't run the function while throttle timer is true
    if (throttleTimer) return;
     
    //first set throttle timer to true so the function doesn't run
    throttleTimer = true;
     
    setTimeout(function() {
        //call the callback function in the setTimeout and set the throttle timer to false after the indicated time has passed 
        callback();
        throttleTimer = false;
    }, time);
}

var elementInView = function(el, offset) {
  var offset = 0;
  var elementTop = el.getBoundingClientRect().top;
 
  return (
    elementTop <= 
    ((window.innerHeight || document.documentElement.clientHeight) - offset)
  );
};

var elementOutofView = function(el) {
  var elementTop = el.getBoundingClientRect().top;

  return (
    elementTop > (window.innerHeight || document.documentElement.clientHeight)
  );
};

var displayScrollElement = function(element) {
  element.classList.add("scrolled");
};

var hideScrollElement = function(element) {
  element.classList.remove("scrolled");
};
 
var handleScrollAnimation = function() {
  scrollElements.forEach(function(el) {
    if (elementInView(el, 1.25)) {
      displayScrollElement(el);
    } else if (elementOutofView(el)) {
      hideScrollElement(el)
    }
  })
}

/* STEPS BAR */

let stepsBarHeight= () => {
	if (typeof(document.querySelector(".steps__bar")) != 'undefined' && document.querySelector(".steps__bar") != null) {

	let stepButtons = document.querySelectorAll(".steps__btn");

	for(let i = 0; i < stepButtons.length; i++ ) {
		stepButtons[i].addEventListener("click", (e) => {
			let stepButton = stepButtons[i];
			stepButton.parentNode.classList.toggle('active');
		});
	}
	
	let stepBlocks = document.querySelectorAll(".steps__block");
	let stepBlocksLength = stepBlocks.length;

	let stepBar = document.querySelector(".steps__bar");
	let stepBarInner = document.querySelector(".steps__bar__inner");
	let stepBarHeight = stepBar.parentNode.offsetHeight - (stepBar.parentNode.offsetHeight / stepBlocksLength);
	let stepBarTop = stepBar.getBoundingClientRect().top;
	// let stepBarBottom = stepBarTop + stepBarHeight;

	stepBar.style.height = stepBarHeight + "px";

	let scrollStep = () => {
		let top  = window.pageYOffset || document.documentElement.scrollTop;
		let trigger = Math.round(top + window.innerHeight);
		let stepBarProgress = Math.round((window.pageYOffset + (window.innerHeight / 2) - stepBarTop));
		if (trigger > stepBarTop) {
			stepBarInner.style.height = stepBarProgress + "px";
		}
	}

	window.addEventListener('scroll', function() {
		throttle(scrollStep, false, 100);
	});

	};
}

stepsBarHeight();

let resizeSteps = debounce(function() {
	stepsBarHeight();
}, 250);

window.addEventListener("resize", resizeSteps);
 
// window.addEventListener('scroll', function() {
//   throttle(handleScrollAnimation, timerThree, 250);
// })

/* Smooth Scroll */
/* https://github.com/cferdinandi/smooth-scroll */
new SmoothScroll('a[href*="#"]:not(a[href*="#tarteaucitron"])', {
	speed: 1000,
	speedAsDuration: true,
	easing: 'easeInOutQuart'
});

// Nice select

let selectBlackLeather = document.querySelector(".select-black-leather");
let selectColoredLeather = document.querySelector(".select-colored-leather");


let generateSelect = (sel) => {
	let price = sel.parentNode.querySelector('.tarif__select__price');
	NiceSelect.bind(sel, {
		placeholder: 'sélectionner le type de véhicule'
	});
	sel.addEventListener("change", () => {
		console.log(price);
		price.innerHTML = sel.value + "€";
	});
}

if (typeof(selectBlackLeather) != 'undefined' && selectBlackLeather != null) {
	generateSelect(selectBlackLeather);
}

if (typeof(selectColoredLeather) != 'undefined' && selectColoredLeather != null) {
	generateSelect(selectColoredLeather);
}
